import { currentOrganizationId } from "./workspace-context";
import { loadingTiming } from "./performance";
export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message);
  }
}
export async function api<T>(
  path: string,
  method = "GET",
  input?: unknown,
  signal?: AbortSignal,
): Promise<T> {
  const start = performance.now();
  const response = await fetch(path, {
    method,
    credentials: "same-origin",
    signal,
    headers: {
      "Content-Type": "application/json",
      ...(currentOrganizationId()
        ? { "X-Knowledge-Organization": currentOrganizationId()! }
        : {}),
    },
    body: input === undefined ? undefined : JSON.stringify(input),
  });
  const result = (await response.json()) as T & {
    error?: string;
    chatId?: string;
  };
  const metric =
    path === "/api/session"
      ? "session"
      : path === "/api/tree"
        ? "tree"
        : path === "/api/onboarding/ensure"
          ? "onboarding"
          : undefined;
  if (metric) loadingTiming(metric, start, { status: response.status });
  if (!response.ok)
    throw Object.assign(
      new ApiError(response.status, result.error ?? "Request failed."),
      { chatId: result.chatId },
    );
  return result;
}
export function socketUrl(path: string) {
  const url = new URL(path, location.href);
  if (currentOrganizationId() && !url.searchParams.has("organizationId"))
    url.searchParams.set("organizationId", currentOrganizationId()!);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return url;
}
